import Vue from "vue";

function initialState() {
  return {
    selectedEvent: null,
    selectedSchedule: null,
    selectedSeats: [],
    selectedSeatName: []
  };
}

const state = initialState();

const mutations = {
  ADD_SELECTED_EVENT(state, payload) {
    state.selectedEvent = payload;
  },
  ADD_SELECTED_SCHEDULE(state, payload) {
    state.selectedSchedule = payload;
  },
  ADD_SELECTED_SEATS(state, payload) {
    if (state.selectedSeats.length == 0) {
      payload["no_of_seat"] = 1;
      payload["cost"] = payload["price"];
      state.selectedSeats.push(payload);
    } else {
      const arr = state.selectedSeats.filter(item => {
        if (parseInt(item.seat_type_id) == parseInt(payload.seat_type_id)) {
          item.no_of_seat = item.no_of_seat + 1;
          item.cost = item.no_of_seat * item.price;
          return item;
        }
      });
      if (arr.length == 0) {
        payload["no_of_seat"] = 1;
        payload["cost"] = payload["price"];
        state.selectedSeats.push(payload);
      }
    }
    console.log(state.selectedSeats);
  },
  REMOVE_SELECTED_SEATS(state, payload) {
    if (payload.no_of_seat == 0) {
      const arr = state.selectedSeats
        .map(item => {
          return item.seat_type_id;
        })
        .indexOf(payload.seat_type_id);
        state.selectedSeats.splice(arr, 1);
    } else {
      const arr = state.selectedSeats.filter(item => {
        if (parseInt(item.seat_type_id) == parseInt(payload.seat_type_id)) {
          item.no_of_seat = item.no_of_seat - 1;
          item.cost = item.no_of_seat * item.price;
          return item;
        }
      });
    }
     },
  ADD_SELECTED_SEAT_NAME(state, payload) {
    if (state.selectedSeatName.length == 0 || state.selectedSeats.length == 0) {
      state.selectedSeatName.pop();
      state.selectedSeatName.push(payload);
    }
  },
  REMOVE_ALL_SELECTED_SEATS(state, payload) {
    state.selectedSeats.splice(0, state.selectedSeats.length);
    state.selectedSeatName.splice(0, state.selectedSeatName.length);
    console.log("REMOVE", state.selectedSeats, state.selectedSeatName);
  }
};

const actions = {
  async addSelectedEvent(context, payload) {
    await context.commit("ADD_SELECTED_EVENT", payload);
  },
  async addSelectedSchedule(context, payload) {
    await context.commit("ADD_SELECTED_SCHEDULE", payload);
  },
  async addSelectedSeats(context, payload) {
    await context.commit("ADD_SELECTED_SEATS", payload);
  },
  async removeSelectedSeats(context, payload) {
    await context.commit("REMOVE_SELECTED_SEATS", payload);
  },
  async addSelectedSeatName(context, payload) {
    await context.commit("ADD_SELECTED_SEAT_NAME", payload);
  },
  async removeAllSelectedSeats(context, payload) {
    await context.commit("REMOVE_ALL_SELECTED_SEATS", payload);
  }
};

const getters = {
  getSelectedEvent: state => state.selectedEvent,
  getSelectedSeats: state => state.selectedSeats,
  getSelectedSchedule: state => state.selectedSchedule,
  getSelectedSeatName: state => state.selectedSeatName
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/events.js